import { Component, Input, OnInit } from "@angular/core";
import { Order } from "../../../../objects/orders/order";
import { OrderStatus } from "../../../../objects/orders/orderStatus";
import { ActivatedRoute, Router } from "@angular/router";
import { OrderSearch } from "../../../../objects/responses/orderSearch";
import { BaseOrderItemComponent } from "./base-order-item.component";
import { OrderHelper } from "../../../../common/helpers/orderHelper";
import { Column } from "../../../../objects/users/user";
import { CalculatorHelper } from "../../../../common/helpers/calculatorHelper";
import { LocationUtil } from "../../../../common/utils/LocationUtil";
import { PropertyHelper } from "../../../../common/helpers/propertyHelper";
import { CanadianCurrencyCode } from "../../../../objects/currencyExchange/canadianCurrencyCode";
import { OrderOptions } from "../../../../objects/orders/orderOptions";

/**
 * Created by alex.y on 9/13/2017.
 */
@Component({
    selector: 'order-item',
    templateUrl: 'orderItem.component.html',
    moduleId: module.id.toString()
})
export class OrderItemComponent extends BaseOrderItemComponent{

    @Input()
    public order: Order;

    @Input()
    public topClass: string = "col-sp-5";


    @Input()
    public topClassNext: string = "";

    @Input()
    private paramsInUrl: OrderSearch = new OrderSearch();

    @Input()
    public isDisabled: boolean = false;

    @Input()
    private unblurId: string = "";

    @Input()
    public columns: Column[] = [];

    public canadianCurrencyCodes: CanadianCurrencyCode[];

    public orderStatus = OrderStatus;

    public orderHelper = OrderHelper;

    public calculatorHelper = CalculatorHelper;

    public orderOptions = OrderOptions;

    constructor(public router: Router, public route: ActivatedRoute) {
        super();

        if(this.route.snapshot.data && this.route.snapshot.data.canadianCurrencyCodes)
            this.canadianCurrencyCodes = this.route.snapshot.data.canadianCurrencyCodes.Data;
    }

    public get topClassStyle(): any {
        let o = {};
        o[this.topClass] = true;
        o["disabled"] = this.isDisabled;
        return o;
    }

    public goToDetails(id: number): void {
        this.goToDetailsBase(id, this.router, this.paramsInUrl, this.unblurId, this.order);
    }

    public getTotalPrice(): number {
        let result: number = 0;

        for (let item of this.order.OrderItems) {
            result += item.Total.TotalPrice;
        }

        return result;
    }

    public getColumnByName(name: string){
        return this.columns.find(x=> x.Name == name);
    }
}


// WEBPACK FOOTER //
// ./app/components/Managment/orderManagement/orderItem/orderItem.component.ts